export const constant = {
	selector: {
		shiftTrigger: 'data-move',
		elementWithAffectedScroll: '.js-movable',
		elementScrollToView: '.js-scroll-to-view',
	},
}
